module.exports = __webpack_public_path__ + "img/gongjian.prt.6bc09cc9.jpg";